import React, { useState, useEffect } from "react";
import { Button, Form, Input, Select, Checkbox } from "antd";
import logo from "../../img/Logo_black.png";
import Check from "./Check";
import { useTranslation } from "react-i18next";
import ChangeLang from "../ChangeLang";
import SendVerify from "./SendVerify";
import InputMask from "react-input-mask";

function FormOnco() {
  const { Option } = Select;
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [change, setChange] = useState(false);
  const [isModalOpenVerify, setIsModalOpenVerify] = useState(false);
  const [verifyData, setVerifyData] = useState();

  const showDrawer = () => {
    setOpen(true);
  };

  const onFinish = async (values) => {
    const dataMsg = {
      department: values.section,
      roomNumber: values.numberRoom,
      problem: values.problem,
      name: values.name,
      surname: values.surName,
      phoneNumber: values.phone,
      ip: "",
    };
    await setVerifyData(dataMsg);
    setIsModalOpenVerify(true);
  };

  return (
    <div className="form">
      <SendVerify
        vrOpen={isModalOpenVerify}
        vrClose={setIsModalOpenVerify}
        vrData={verifyData}
      />
      <Check open={open} setOpen={setOpen} />

      <div className="form__item">
        <Form layout="vertical" name="control-ref" onFinish={onFinish}>
          <nav>
            <div className="form__logo">
              <img src={logo} className="imgOnco" alt="logo" />
            </div>
            <div className="form__check">
              <Button onClick={showDrawer}>{t("nav.2")}</Button>
              <ChangeLang />
            </div>
          </nav>
          <h1>{t("titles.0")}</h1>

          <Form.Item
            name="section"
            label={t("titles.1")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select placeholder={t("deportmanOnco.0")} allowClear>
              <Option value={t("deportmanOnco.1")}>
                {t("deportmanOnco.1")}
              </Option>
              <Option value={t("deportmanOnco.2")}>
                {t("deportmanOnco.2")}
              </Option>
              <Option value={t("deportmanOnco.3")}>
                {t("deportmanOnco.3")}
              </Option>
              <Option value={t("deportmanOnco.4")}>
                {t("deportmanOnco.4")}
              </Option>
              <Option value={t("deportmanOnco.41")}>
                {t("deportmanOnco.41")}
              </Option>
              <Option value={t("deportmanOnco.5")}>
                {t("deportmanOnco.5")}
              </Option>
              <Option value={t("deportmanOnco.6")}>
                {t("deportmanOnco.6")}
              </Option>
              <Option value={t("deportmanOnco.7")}>
                {t("deportmanOnco.7")}
              </Option>
              <Option value={t("deportmanOnco.8")}>
                {t("deportmanOnco.8")}
              </Option>
              <Option value={t("deportmanOnco.9")}>
                {t("deportmanOnco.9")}
              </Option>
              <Option value={t("deportmanOnco.10")}>
                {t("deportmanOnco.10")}
              </Option>
              <Option value={t("deportmanOnco.11")}>
                {t("deportmanOnco.11")}
              </Option>
              <Option value={t("deportmanOnco.12")}>
                {t("deportmanOnco.12")}
              </Option>
              <Option value={t("deportmanOnco.13")}>
                {t("deportmanOnco.13")}
              </Option>
              <Option value={t("deportmanOnco.14")}>
                {t("deportmanOnco.14")}
              </Option>
              <Option value={t("deportmanOnco.15")}>
                {t("deportmanOnco.15")}
              </Option>
              <Option value={t("deportmanOnco.16")}>
                {t("deportmanOnco.16")}
              </Option>
              <Option value={t("deportmanOnco.17")}>
                {t("deportmanOnco.17")}
              </Option>
              <Option value={t("deportmanOnco.18")}>
                {t("deportmanOnco.18")}
              </Option>
              <Option value={t("deportmanOnco.19")}>
                {t("deportmanOnco.19")}
              </Option>
              <Option value={t("deportmanOnco.20")}>
                {t("deportmanOnco.20")}
              </Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="numberRoom"
            label={t("titles.2")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="problem"
            label={t("titles.3")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            {!change ? (
              <Select placeholder={t("problem.0")} allowClear>
                <Option value={t("problem.1")}>{t("problem.1")}</Option>
                <Option value={t("problem.2")}>{t("problem.2")}</Option>
                <Option value={t("problem.3")}>{t("problem.3")}</Option>
                <Option value={t("problem.4")}>{t("problem.4")}</Option>
                <Option value={t("problem.5")}>{t("problem.5")}</Option>
              </Select>
            ) : (
              <Input.TextArea rows="3" placeholder="Muammoni kirting" />
            )}
          </Form.Item>
          <Form.Item>
            <Checkbox onChange={(e) => setChange(e.target.checked)}>
              {t("titles.4")}
            </Checkbox>
          </Form.Item>
          <Form.Item
            name="name"
            label={t("titles.5")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="surName"
            label={t("titles.6")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="phone"
            label={t("titles.7")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <InputMask
              className="phoneInp ant-input-number ant-input-number-input"
              mask="99-999-99-99"
              required
            />
          </Form.Item>
          <Form.Item>
            <Button htmlType="submit" type="primary" block>
              {t("titles.8")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

export default FormOnco;
